import CurrencyContext from 'contexts/currencyContext'
import GeoContext from 'contexts/geoContext'
import * as CurrencyHelper from 'lib/formatCurrency'
import React, { useContext } from 'react'

type FormatType = 'dynamicDollar' | 'dynamic' | 'preciseDollar' | 'precise' | 'blank' | 'blankDollar' | 'rounded' | 'roundedDollar'

interface Props {
  value: number;
  currency?: string;
  format?: FormatType;
}

function formatFn(value: number, currencyCode: string, format: FormatType, regionCode?: string) {
  // Show blank amount if `value` can't be parsed as a number (e.g. null or undefined)
  if (isNaN(parseFloat(value as any))) {
    return format.includes('Dollar') ?
      CurrencyHelper.blankAmountWithDollarType(currencyCode) :
      CurrencyHelper.blankAmount(currencyCode)
  }

  switch (format) {
    case 'blank':
      return CurrencyHelper.blankAmount(currencyCode)
    case 'blankDollar':
      return CurrencyHelper.blankAmountWithDollarType(currencyCode)
    case 'dynamic':
      return CurrencyHelper.formatDynamicAmount(value, currencyCode, false, regionCode)
    case 'dynamicDollar':
      return CurrencyHelper.formatDynamicAmountWithDollarType(value, currencyCode, regionCode)
    case 'preciseDollar':
      return CurrencyHelper.formatPreciseAmountWithDollarType(value, currencyCode)
    case 'precise':
      return CurrencyHelper.formatPreciseAmount(value, currencyCode)
    case 'rounded':
      return CurrencyHelper.formatRoundedAmount(value, currencyCode)
    case 'roundedDollar':
      return CurrencyHelper.formatRoundedAmountWithDollarType(value, currencyCode)
    default:
      return null
  }
}

function FormatCurrency(props: Props) {
  const { format = 'dynamicDollar' } = props
  const geo = useContext(GeoContext)
  const contextCurrency = useContext(CurrencyContext)
  const currencyCode = props.currency ?? contextCurrency ?? geo.currentCurrency
  const formatted = formatFn(props.value, currencyCode, format, geo.currentRegionCode)

  return <>{formatted}</>
}

export default React.memo(FormatCurrency)
